import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import * as currentOrder from '../../actionCreators/currentOrder';
import { getType } from 'typesafe-actions';

const initialState = null as null | number;

const slice = createSlice({
  name: '$bestEstId',
  initialState,
  reducers: {
    setBestEstId(state, action: PayloadAction<number>) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(getType(currentOrder.resetOrder), () => initialState);
  },
});

export const { setBestEstId } = slice.actions;

export default slice.reducer;
